document.addEventListener('click',event=>{const open=event.target.closest('[data-astra-open]');if(open){const dialog=document.getElementById(open.dataset.astraOpen);if(dialog&&!dialog.open){dialog.showModal();dialog._astraOpener=open;}return;}const close=event.target.closest('[data-astra-close]');if(close){const dialog=close.closest('dialog');dialog.close();dialog._astraOpener?.focus();}});document.addEventListener('close',event=>{if(event.target.matches?.('.astra-size-dialog'))event.target._astraOpener?.focus();},true);

document.addEventListener("click",event=>{const trigger=event.target.closest("[data-astra-expand]");if(!trigger)return;const panel=document.getElementById(trigger.dataset.astraExpand);if(panel){panel.open=true;panel.querySelector("summary")?.focus({preventScroll:true});}});

document.addEventListener('click',event=>{const link=event.target.closest('.cart__item-remove a');if(!link||link.closest('#CartPageForm'))return;const item=link.closest('.cart__item');const selector=item?.querySelector('quantity-selector');if(!selector||!customElements.get('quantity-selector'))return;const key=selector.getAttribute('key');if(!key)return;event.preventDefault();selector.dispatchEvent(new CustomEvent('cart:quantity',{bubbles:true,detail:[key,'0',selector]}));});

document.addEventListener("cart:updated",event=>{if(document.body.classList.contains("template-cart")&&event.detail?.cart?.item_count===0)location.reload();});

// Keep the cart footer inside the actual viewport, including compact headers.
(()=>{
  let frame;
  function fitCart(){
    frame = null;
    const viewport = window.visualViewport;
    const bottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
    document.querySelectorAll('.cart__drawer-form').forEach(form=>{
      const top = form.getBoundingClientRect().top;
      if(top < 0 || top >= bottom)return;
      const space = Math.max(220,Math.floor(bottom-top))+'px';
      if(form.style.getPropertyValue('--astra-cart-space')!==space)form.style.setProperty('--astra-cart-space',space);
    });
  }
  function scheduleFit(){if(!frame)frame=requestAnimationFrame(fitCart);}
  document.addEventListener('cart:open',()=>{scheduleFit();setTimeout(scheduleFit,350);});
  window.addEventListener('resize',scheduleFit,{passive:true});
  window.visualViewport?.addEventListener('resize',scheduleFit,{passive:true});
})();

// Complete a pair by adding only the missing real leash or collar. Shopify applies the discount.
document.addEventListener('click',async event=>{
  const width=event.target.closest('[data-set-offer-width]');
  if(width){width.parentElement.querySelectorAll('[data-set-offer-width]').forEach(option=>option.setAttribute('aria-pressed',String(option===width)));const hint=width.closest('[data-set-offer]')?.querySelector('[data-set-offer-hint]');if(hint)hint.hidden=true;return;}
  const button=event.target.closest('[data-set-offer-add]');
  if(!button||button.disabled)return;
  const offer=button.closest('[data-set-offer]');
  const choice=offer.querySelector('[data-set-offer-width][aria-pressed="true"]')||offer;
  const leashId=Number(choice.dataset.variantId||choice.dataset.leashId);
  if(!leashId){
    // Collar offer: the size is never preselected.
    const hint=offer.querySelector('[data-set-offer-hint]');
    if(hint){hint.hidden=false;offer.querySelector('[data-set-offer-width]')?.focus();}
    return;
  }
  const root=window.Shopify?.routes?.root||'/';
  const post=(path,body)=>fetch(root+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)});
  const error=offer.querySelector('[data-set-offer-error]');
  error.hidden=true;button.disabled=true;button.setAttribute('aria-busy','true');
  let added=false;
  try{
    const add=await post('cart/add.js',{items:[{id:leashId,quantity:1}],sections:['cart-ajax'],sections_url:location.pathname});
    if(!add.ok)throw new Error('add');
    added=true;
    const sections=(await add.json()).sections;
    const update=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!update.ok)throw new Error('cart');
    const cart=await update.json();
    // The cart count listener reads the drawer markup from the event.
    cart.sections=sections;
    if(document.body.classList.contains('template-cart')){location.reload();return;}
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
  }catch(failure){
    // Once the set is in the cart, show the real cart rather than inviting a second add.
    if(added){location.assign(root+'cart');return;}
    error.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');
  }
});
